// Service layer for Questionnaires and Responses
import { supabase } from '../lib/supabase';

export const questionnaireService = {
  // Get questionnaires for a project
  async getByProjectId(projectId) {
    const { data, error } = await supabase?.from('questionnaires')?.select(`
        *,
        questionnaire_responses(
          *,
          vendors(*)
        )
      `)?.eq('project_id', projectId);

    if (error) throw error;

    return data?.map(q => ({
      id: q?.id,
      projectId: q?.project_id,
      title: q?.title,
      description: q?.description,
      questions: q?.questions,
      responses: q?.questionnaire_responses || [],
      createdAt: q?.created_at,
      updatedAt: q?.updated_at
    }));
  },

  // Create questionnaire
  async create(questionnaireData) {
    const { data: { user } } = await supabase?.auth?.getUser();
    if (!user) throw new Error('Not authenticated');

    const { data, error } = await supabase?.from('questionnaires')?.insert({
        project_id: questionnaireData?.projectId,
        title: questionnaireData?.title,
        description: questionnaireData?.description,
        questions: questionnaireData?.questions || []
      })?.select()?.single();

    if (error) throw error;
    return data;
  },

  // Submit response to questionnaire
  async submitResponse(questionnaireId, vendorId, responses) {
    const { data, error } = await supabase?.from('questionnaire_responses')?.upsert({
        questionnaire_id: questionnaireId,
        vendor_id: vendorId,
        responses: responses
      })?.select()?.single();

    if (error) throw error;
    return data;
  },

  // Get responses for a questionnaire
  async getResponses(questionnaireId) {
    const { data, error } = await supabase?.from('questionnaire_responses')?.select(`
        *,
        vendors(*)
      `)?.eq('questionnaire_id', questionnaireId);

    if (error) throw error;

    return data?.map(response => ({
      id: response?.id,
      questionnaireId: response?.questionnaire_id,
      vendorId: response?.vendor_id,
      vendor: response?.vendors,
      responses: response?.responses,
      submittedAt: response?.submitted_at
    }));
  }
};
